/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { task, TaskInstance } from 'ember-concurrency';

interface DiscardModalArgs {
  isSaving: boolean;
  hasErrors: boolean;
  errorString: string;
  hasReadOnlyPermission: boolean;
  onClose: () => unknown;
  onSave: () => TaskInstance<unknown>;
  onDiscard: () => unknown;
}

export default class DiscardModal extends Component<DiscardModalArgs> {
  onSaveTask = task(async () => {
    await this.args.onSave();
    this.args.onDiscard();
  });
}
